"use strict";

exports.__esModule = true;
exports.default = void 0;

var _tabs = _interopRequireDefault(require("./tabs"));

var _tab = _interopRequireDefault(require("./tab"));

var _plugins = require("../../utils/plugins");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = {
  BTabs: _tabs.default,
  BTab: _tab.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/tabs/index.js
// module id = 281
// module chunks = 43